export default function Hero() {
  return (
    <section id="hero" className="relative flex min-h-[100vh] items-center justify-center overflow-hidden bg-background-950">
      <img
        src="https://readdy.ai/api/search-image?query=stylized%20artistic%20anime%20landscape%20of%20a%20starry%20night%20sky%20over%20a%20distant%20glowing%20city%20and%20hills%2C%20warm%20orange%20and%20amber%20city%20lights%20against%20deep%20teal%20night%2C%20shooting%20stars%2C%20dreamy%20cinematic%20atmosphere%2C%20soft%20bokeh%2C%20hand%20painted%20anime%20style%2C%20evokes%20late%20night%20binge%20watching%20under%20the%20stars&width=1600&height=1000&seq=hero-main&orientation=landscape"
        alt="小虎看番首页背景：星空下的深夜城市"
        title="小虎看番 - 熬夜补番清单"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-background-950" />

      <div className="relative z-10 mx-auto flex w-full max-w-4xl flex-col items-center px-4 py-28 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-medium text-background-100 backdrop-blur-sm">
          <i className="ri-fire-fill text-primary-400" />
          熬夜补番清单 · 持续更新
        </span>

        <h1 className="mt-6 font-heading text-4xl leading-tight text-background-50 md:text-6xl">
          小虎看番<span className="text-primary-400">·</span>照单刷番
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-7 text-background-200 md:text-lg">
          高分番榜、冷门佳作、完结番合集，一部部口碑经得起考验的好番已经备好。小虎帮你从片海挑出真正值得看完的那一部，今晚就开刷。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a
            href="#top"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-trophy-line" />
            看高分番榜
          </a>
          <a
            href="#gems"
            className="inline-flex items-center justify-center gap-2 rounded-full border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur-sm hover:bg-background-50/20 transition-colors whitespace-nowrap"
          >
            <i className="ri-gemini-line" />
            挖冷门佳作
          </a>
        </div>

        <dl className="mt-14 grid w-full max-w-2xl grid-cols-2 gap-4 sm:grid-cols-4">
          {[
            { num: '300+', label: '精选好番' },
            { num: '9.0+', label: '平均口碑分' },
            { num: '50+', label: '冷门佳作' },
            { num: '24h', label: '清单实时更新' },
          ].map((s) => (
            <div key={s.label} className="rounded-lg bg-background-50/10 px-3 py-4 backdrop-blur-sm">
              <dt className="font-heading text-2xl text-primary-400 md:text-3xl">{s.num}</dt>
              <dd className="mt-1 text-xs text-background-200">{s.label}</dd>
            </div>
          ))}
        </dl>
      </div>

      <a
        href="#top"
        aria-label="向下滚动"
        className="absolute bottom-6 left-1/2 z-10 inline-flex h-10 w-10 -translate-x-1/2 items-center justify-center rounded-full border border-background-50/30 text-background-50 hover:bg-background-50/10 transition-colors"
      >
        <i className="ri-arrow-down-line" />
      </a>
    </section>
  );
}